/*eslint-disable*/
export default function Footer() {
  return (
    <div className="z-[5] mx-auto flex w-full max-w-screen-sm flex-col items-center justify-between px-[20px] pb-4 lg:mb-6 lg:max-w-[100%] lg:flex-row xl:mb-2 xl:w-[1310px] xl:pb-6">
        <h6 className="flex items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse text-gray-400">Designed By</h6>
      <p className="mb-6 text-center text-sm text-gray-600 md:text-base lg:mb-0">
        ©{new Date().getFullYear()} <a href="https://www.thebytecloud.tech/" className="hover:underline">TheByteCloud LLC</a>. All Rights Reserved.
      </p>
    </div>
  );
}
